import { DolfinDiagram } from '../diagram'
import DolfinFlowExecutor from '../flow-executor/base'
import { NodeError, NodeWarning } from '../types'
import { DolfinNode } from './base'
import { TypedNode } from './types'

/**
 * Start node - entry point of all diagrams.
 *
 * @see /docs/domain/nodes/start.md for canonical documentation
 */
export class StartNode<T extends DolfinFlowExecutor> extends DolfinNode<
  T,
  'start'
> {
  async process(): Promise<boolean> {
    return true
  }

  async parse() {
    return this.node
  }

  static validate(
    node: TypedNode<'start'>,
    diagram: DolfinDiagram
  ): {
    errors: NodeError[]
    warnings: NodeWarning[]
  } {
    const superValidation = super.validate(node, diagram)

    return {
      errors: [...superValidation.errors],
      warnings: [...superValidation.warnings]
    }
  }
}
